import { render } from "./CommissionTable.vue?vue&type=template&id=2aba14fc&scoped=true&ts=true"
import script from "./CommissionTable.vue?vue&type=script&lang=ts"
export * from "./CommissionTable.vue?vue&type=script&lang=ts"

import "./CommissionTable.vue?vue&type=style&index=0&id=2aba14fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aba14fc"]])

export default __exports__